const ADMIN_REFERRAL_CODE_MAX_LENGTH = 20;

export const REFERRAL_CODE_TAKEN_MESSAGE = 'Referral code already taken.';
export const ALPHANUMERIC_REFERRAL_CODE_MESSAGE =
  'Only alphanumeric digits allowed.';
export const REFERRAL_CODE_MAX_LENGTH_MESSAGE =
  'Maximum 20 characters allowed.';

export function validateAdminConsumerUpdatePayload(consumerData) {
  const referralCode = (consumerData.referral_code || '').trim();

  if (!referralCode) {
    return null;
  }

  if (referralCode.length > ADMIN_REFERRAL_CODE_MAX_LENGTH) {
    return REFERRAL_CODE_MAX_LENGTH_MESSAGE;
  }

  if (!/^[a-z0-9]+$/i.test(referralCode)) {
    return ALPHANUMERIC_REFERRAL_CODE_MESSAGE;
  }

  return null;
}

export function buildAdminConsumerUpdatePayload(consumerData) {
  const referralCode = (consumerData.referral_code || '').trim().toUpperCase();

  return {
    name: consumerData.name,
    referral_code: referralCode,
    is_affiliate: Boolean(consumerData.is_affiliate),
  };
}

export function resolveUpdateConsumerErrorMessage(error) {
  const responseData = error && error.response && error.response.data;
  const message = responseData && responseData.message;

  if (message === REFERRAL_CODE_TAKEN_MESSAGE) {
    return null;
  }
  if (message === ALPHANUMERIC_REFERRAL_CODE_MESSAGE) {
    return message;
  }
  if (message === REFERRAL_CODE_MAX_LENGTH_MESSAGE) {
    return message;
  }
  if (message) {
    return null;
  }
  return 'Failed to update consumer';
}
